<template>
  <Teleport to="body">
    <OverlayElement :visible="visible" @click="hide" />
    <div
      class="modal"
      :class="{ 'modal--visible': visible, 'modal--large': large }"
      ref="modal"
      :inert="!visible"
    >
      <div class="modal__close" @click="hide" title="Fermer">
        <PhX />
      </div>
      <div v-if="title" class="modal__title">
        <component v-if="icon" :is="icon" class="modal__icon" />
        <span>{{ title }}</span>
      </div>
      <div class="modal__content">
        <slot></slot>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import '@/assets/css/components/_modal.css'
import OverlayElement from '@/components/OverlayElement.vue'
import { PhX } from '@phosphor-icons/vue'
import { type Ref, ref } from 'vue'

const visible: Ref<boolean> = ref(false)

const emit = defineEmits(['show', 'hide'])

defineProps({
  title: {
    type: String,
    default: '',
  },
  icon: {
    type: Object,
    default: () => undefined,
  },
  large: {
    type: Boolean,
    default: () => false,
  },
})

function show() {
  // on affiche la modal
  emit('show')
  visible.value = true
}
function hide() {
  emit('hide')
  visible.value = false
}

defineExpose({ show, hide })
</script>
